module.exports = __webpack_public_path__ + "static/media/photo173.b9d16519.jpg";